import React from "react";
import { ReactComponent as Leetcode } from "../helper/svgicon/socials/Leetcode.svg";
import { ReactComponent as Hackerrank } from "../helper/svgicon/socials/Hackerrank.svg";
import { ReactComponent as Github } from "../helper/svgicon/socials/Github.svg";
import { ReactComponent as LinkedIn } from "../helper/svgicon/socials/LinkedIn.svg";
import style from "../sass/icons.module.scss";
const Profiles = () => {
     return (
          <div className={style.icons}>
               <a href="https://www.linkedin.com/in/richhapalchoudhary/" target="_blank" rel="noopener noreferrer">
                    <LinkedIn />
               </a>
               <a href="https://github.com/richhapal" target="_blank" rel="noopener noreferrer">
                    <Github />
               </a>
               <a href="https://www.hackerrank.com/richhapal10" target="_blank" rel="noopener noreferrer">
                    <Hackerrank />
               </a>
               <a href="https://leetcode.com/richhapal_choudhary/" target="_blank" rel="noopener noreferrer">
                    <Leetcode />
               </a>
          </div>
     );
};
export default Profiles;
